module.exports = __webpack_public_path__ + "a608ce6a819c2de7637ed80e153f127f.pdf";